import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Tour from "reactour";
import { Container, Row } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { getBlock } from "../../../service/getBlock";
import { postBlock } from "../../../service/postBlock";
import Main from "../../../components/Main/index";
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Table from "../../../components/Table";
import Modal from "../../../components/ModalSuccessMessage";
import SideContainerAnimated from "../../../components/SideContainer";
import SideForm from "../../../components/SideForm";
import DropdownButton from "../../../components/DropdownButton";
import CreditCard from "../../../components/CreditCard/index.js";
import ModalShare from "../../../components/ModalShare";
import ButtonHelper from "../../../components/ButtonHelper";
import FormAddClient from "../../../components/FormAddClient";
import FormEditOrViewClient from "../../../components/FormEditOrViewClient";
import TourComponent from "../../../components/Tour";
import { Td, IconCard } from "./styles";
import { closeModal, openModal } from "../../../helpers/modalFunctions";
import { serverPath } from "../../../helpers/helpersVariables";
import { initialSelectedClient } from "../../../helpers/initialSelectedClient";
import routes from "../../../routes/clientClientPortal.routes";
import creditCard from "../../../assets/icons/credit-card.svg";
import creditCardHover from "../../../assets/icons/credit-card-hover.svg";
import color from "../../../assets/css/colors";
import iconPlay from "../../../assets/icons/play.svg"
import { ClientDataInterface, CreditCardInterface } from "./interfaces";
import { toastCreate } from "../../../utils/notifications/toast";
import { ETypeTransactions } from "../../../utils/typeTransactions";
import { sendWhatsapp } from "../../../utils/sendPaymentLink/sendWhatsapp";
import { sendEmail } from "../../../utils/sendPaymentLink/sendEmail";
import { tourVersionHandler } from "../../../utils/tourVersion";
import { useFormClient } from "../../../hooks/useFormClient";
import { 
  stepGenTokenCardLink, 
  stepsTableClients, 
  stepsTypeClientRegister 
} from "../../../helpers/stepsForTours";
import TableHeadClient from "../../../components/ClientTableHead";
import Animation from "../../../components/Animation/animation";
import api from "../../../service/api";
import { useQuery } from "react-query";

const Client = (): React.ReactElement => {
  const [clientsData, setClientsData] = useState<Array<ClientDataInterface>>([]);
  const [selectedClient, setSelectedClient] = useState<ClientDataInterface>(initialSelectedClient);
  
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(false)
  
  const [message, setMessage] = useState("");

  const [cardIdHover, setCardIdHover] = useState<string>();
  const [cardData, setCardData] = useState<Array<CreditCardInterface>>([]);

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  const [isTourOpen, setIsTourOpen] = useState(false);
  const [isTutorialTourOpen, setIsTutorialTourOpen] = useState(false);
  const [isTutorialToken, setIsTutorialToken] = useState(false);

  const login = useSelector((state: {login: any}) => state.login);
  const history = useHistory();

  const [ linkForTokenCard, setLinkForTokenCard ] = useState("");
  const [idLink, setIdLink] = useState("");

  function getQueryParams() {
    return new URLSearchParams(useLocation().search);
  }

  const queryParams = getQueryParams();

  const {
    ...restUseForms
  } = useFormClient();

  useEffect(() => {
    if(login.user.groups.cm2 === false){
      history.push("/admin/dashboard");
    }

    if(queryParams.get("tutorial") !== null){
      setTimeout(() => {
        setIsTutorialTourOpen(true);
      }, 1000);
    }
  }, []);

  const createLink = async (user: ClientDataInterface): Promise<void> => {
    const { block, isError } = await postBlock("linkpay/create", {
      "branchsId": login.user.branchsId,
      "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
      "apiOwnerId": login.user.powerUser ? "ZOOP" : login.user.branchs.apiOwner.description,
      "amount": "100",
      "numberInstalments": "1",
      "description": "Link para tokenizar cartão",
      "buyerIdAdquirente": user.buyerIdAdquirente,
      "buyersId": user.id,
      "phoneSms": user.phoneNumber,
      "tpTransaction": ETypeTransactions.SUBSCRIPTION.toString(),
      "standardLogo": login.user.branchs.standardLogo,
      "email": user.email
    })

    if(!isError) {
      setIdLink(block.id)
      setLinkForTokenCard(`${`https://100pay-payment-link.netlify.app/card/token/${block.id}/${login.token}`}`)
      openModal("modalShare");

    } else if (isError) {
      toastCreate(
        "createLink", 
        "error", 
        3000, 
        "Falha ao criar link, entre em contato com o suporte"
      )
    }
  }

  const getClientsDataFromApi = async (
    page: number,
  ): Promise<void> => {

    const { block, loading, isError } = await getBlock("/buyer/list", {
      branchsId: login.user.branchsId,
      page: page
    })

    isError && setIsLoading(true)
    setClientsData(block.Buyers)
    setMaxPage(block.pageCount)
    setIsLoading(loading)
  }

  useQuery(
    ["getClients", page, debouncedSearchTerm, refresh],
    () => {
      if(debouncedSearchTerm === "")  {
        getClientsDataFromApi(page)
      }
    }, 
    { 
      keepPreviousData : true,
      refetchOnWindowFocus: false,
    }
  )

  useQuery(
    ["searchClient", debouncedSearchTerm, page],
    () => {
      if(debouncedSearchTerm !== "")  {
        getBuyersFilteredAtApi(debouncedSearchTerm, page)
      }
    }, 
    { 
      keepPreviousData : true,
      refetchOnWindowFocus: false,
    }
  )

  useEffect(() => {
    setIsLoading(true);

    const timerId = setTimeout(() => {
      setPage(1);
      setDebouncedSearchTerm(searchTerm);
    }, 1200);

    return () => {
      clearTimeout(timerId);
    }

  }, [searchTerm]);

  const getBuyersFilteredAtApi = async (
    debouncedSearchTerm: string, 
    page: number
  ): Promise<void> => {
    const { block, loading, isError } = await getBlock("/buyer/list", {
      branchsId: login.user.branchsId,
      search: debouncedSearchTerm,
      page: page
    })

    const buyers = block.Buyer.map((buyer: any) => {
      return {
        buyerbranch: {
          businessName: login.user.branchs.businessName,
        },
        ...buyer
      }
    });

    isError && setIsLoading(true)
    setClientsData(buyers);
    setMaxPage(block.pageCount)
    setIsLoading(loading);
  }

  useEffect(() => {
    tourVersionHandler(login.user.id, isTutorialToken, setIsTutorialToken, "1.0.3")
  })

  const openCards = async (id: string): Promise<void> => {
    
      if(login.user.groups.cm2r){
        const { block } = await getBlock("/card/list", {
          cardBuyerId: id
        })

        setCardData(block.CardBuyer);
        restUseForms.handlerCardsCredit("open")
      }

  };

  const openViewForm = (): void => restUseForms.handlerFormViewClient("open");

  const openAddForm = (): void => {
      restUseForms.handlerFormAddClient("open")
      tourVersionHandler(login.user.id, isTutorialTourOpen, setIsTourOpen, "1.0.0")
  };

  const openEditForm = (): void => restUseForms.handlerFormEditClient("open");

  const handleExport = async (): Promise<void> => {
    const { data } = await api.get(
      `/adm/ownerbranch/list?id=${login.user.branchsId}&exportFilter=true`
    );
    var hiddenElement = document.createElement("a");
    
    hiddenElement.href = `${serverPath}/${data}`;
    hiddenElement.target = "_blank";
    hiddenElement.download = "Clientes 100pay.csv";
    hiddenElement.click();
  };

  const tableContentGenerator = (): JSX.Element[] | undefined => {
    if(clientsData.length !== 0){
      return clientsData.map((user) => {
        return (
          <motion.tr 
            key={user.id} 
            style={{ height: 67 }}
            layout
          >
            <Td>{user.id}</Td>
            <Td>{user.firstName}</Td>
            <Td>{user.lastName}</Td>
            <Td>{user.status === "active" ? "Ativo" : "Inativo"}</Td>
            <Td>{user.taxpayerId}</Td>
            <Td>{user.buyerbranch.businessName}</Td>
            <Td
              onMouseLeave={() => setCardIdHover("-1")}
              onMouseEnter={() => setCardIdHover(user.id)}
            >
              {
                user.buyerCardIdAdiquirente !== null 
                  ? (
                    <IconCard
                      onClick={() => openCards(user.id)}
                      src={cardIdHover === user.id ? creditCardHover : creditCard}
                      alt="cartão"
                    />
                  ) 
                  : null
              }
            </Td>
            <Td>
              <DropdownButton 
                id="dropdown"
                setIsViewFormVisible={openViewForm} 
                setIsEditFormVisible={openEditForm}
                setGenerateLink={createLink}
                isGenLinkTokenCardVisible={true}
                isViewOptionVisible={login.user.groups.cm2r}
                isEditOptionVisible={login.user.groups.cm2u}
                isRemoveOPtionVisible={false}
                selectedUser={user}
                setSelectedUser={setSelectedClient}
                isTutorialOpen={isTutorialToken}
              />
            </Td>
          </motion.tr>
        )
      });
    }
  };

  const creditCardSvgGenerator = (): JSX.Element[] => {
    return cardData.map((creditCard: CreditCardInterface) => {
      return (
        <div className="pt-5">
          <CreditCard
            firstNumbers={creditCard.first4Digits}
            lastNumbers={creditCard.last4Digits}
            name={creditCard.holderName}
            cvv=""
            valid={`${creditCard.expirationMonth}/${creditCard.expirationYear}`}
          />
        </div>
      )
    })
  }

  const openForm = restUseForms.isEditClientVisible 
    || restUseForms.isAddClientVisible 
    || restUseForms.isViewClientVisible 
    || restUseForms.isOpenCardsCredit

  const sendInWhatsapp = async (): Promise<void> => {
    const { message } = await sendWhatsapp({
        link: linkForTokenCard,
        phoneSms: selectedClient.phoneNumber,
        establishment: login.user.branchs.businessName 
          ? login.user.branchs.businessName 
          : login.user.branchs.businessDescription,
        endpoint: "/buyer/tokencard/send/whats"
    })

    setMessage(message)
  }

  const sendInEmail = async (): Promise<void> => {
    const { message } = await sendEmail({
        email: selectedClient.email,
        link: linkForTokenCard,
        id: idLink,
        establishment: login.user.branchs.businessName 
          ? login.user.branchs.businessName 
          : login.user.branchs.businessDescription,
        endpoint: "/buyer/tokencard/send/email"
    })

    setMessage(message)
  }

  return (
    <Container fluid >
      <ToastContainer/>
      <ButtonHelper options={[
        { 
          name: "Aprenda sobre a tabela e adicionar cliente", 
          function: () => setIsTutorialTourOpen(true), 
          icon: iconPlay
        },
        { 
          name: "Como adicionar um cartão para o cliente", 
          function: () => setIsTutorialToken(true), 
          icon: iconPlay
        }
      ]}/>
      <Row>
        <TourComponent
          isOpen={isTutorialTourOpen}
          setStateToClose={setIsTutorialTourOpen}
          steps={stepsTableClients}
        />
        <TourComponent
          isOpen={isTourOpen}
          setStateToClose={setIsTourOpen}
          steps={stepsTypeClientRegister}
        />
        <Tour
          steps={stepGenTokenCardLink}
          isOpen={isTutorialToken}
          onRequestClose={() => {
            setIsTutorialToken(false)
            closeModal("modalShare")
          }} 
          accentColor={color.primary}
          showNumber={false}
          showNavigation
          showNavigationNumber={false}
          showButtons
          startAt={0}
        />
        <Modal text="Adicionado com Sucesso" />
        <ModalShare 
            modalId={"modalShare"}
            text="Link para cartão assinatura" 
            linkId={linkForTokenCard}
            type={ETypeTransactions.CREDIT_CARD}
            sendEmail={sendInEmail}
            sendWhatsapp = {sendInWhatsapp}
            message={message}
        />
        <Main
          className={` ${openForm ? "col-d-none column-side-open" : "column-content"}`}
          isFormVisible={restUseForms.isAddClientVisible}
        >
          <Header
            title="Clientes"
            subTitle="Visualize e gerencie toda a sua base de clientes em um só lugar"
            subTitleWidth={229}
          />
          <NavTabs tabs={routes}/>
          <Table
            id="table"
            showAddButton={login.user.groups.cm2c}
            showExportButton={login.user.groups.cm2e}
            buttonText="Adicionar Cliente"
            isAddFormVisible={restUseForms.isAddClientVisible}
            setIsAddFormVisible={openAddForm}
            page={page}
            setPage={setPage}
            maximumPage={maxPage}
            handleExport={handleExport}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          >
            <TableHeadClient/>
            {
              isLoading 
              ? <Animation/>
              : <motion.tbody layout>
                {tableContentGenerator()}
              </motion.tbody>
            }
          </Table>
        </Main>

        <FormAddClient
          isVisible={restUseForms.isAddClientVisible}
          setVisible={restUseForms.handlerFormAddClient}
          setRefresh={setRefresh}
        />

        <FormEditOrViewClient
          setSelectedClient={setSelectedClient}
          setRefresh={setRefresh}
          setIsViewFormVisible={restUseForms.handlerFormViewClient}
          setIsEditFormVisible={restUseForms.handlerFormEditClient}
          selectedClient={selectedClient}
          isEditFormVisible={restUseForms.isEditClientVisible}
          isViewFormVisible={restUseForms.isViewClientVisible}
        />

        <SideContainerAnimated isVisible={restUseForms.isOpenCardsCredit}>
          <SideForm
            title="Cartões de Credito"
            icon={creditCardHover}
            sizeIcon={22}
            visible={() => restUseForms.handlerCardsCredit("close")}
          >
            {creditCardSvgGenerator()}
          </SideForm>
        </SideContainerAnimated>
      </Row>
    </Container>
  );
};

export default Client;